import React, { forwardRef } from 'react';
import clsx from 'clsx';

export interface LoadingSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Spinner size */
  size?: 'sm' | 'md' | 'lg';
  /** Override spinner color (CSS color value) */
  color?: string;
}

const sizeClasses: Record<NonNullable<LoadingSpinnerProps['size']>, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

export const LoadingSpinner = forwardRef<HTMLDivElement, LoadingSpinnerProps>(
  ({ size = 'md', color, className, style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        role="status"
        aria-label="Loading"
        className={clsx(
          'inline-block rounded-full border-transparent',
          'animate-[volt-spin_0.75s_linear_infinite]',
          sizeClasses[size],
          className,
        )}
        style={{
          borderTopColor: color ?? 'var(--volt-blue)',
          borderRightColor: 'transparent',
          borderBottomColor: 'transparent',
          borderLeftColor: 'transparent',
          ...style,
        }}
        {...props}
      >
        <span className="sr-only">Loading...</span>
      </div>
    );
  },
);

LoadingSpinner.displayName = 'LoadingSpinner';
